export default {
  cost_one: '{{count}} Punkt',
  cost_other: '{{count}} Punkte',
  discount: '{{count}}% Rabatt',
  available: 'Prämie verdient 🎉',
  unavailable_one: 'Nur noch {{count}} Punkt zur Freischaltung',
  unavailable_other: 'Nur noch {{count}} Punkte zur Freischaltung',
  download_app: '➡️ Folge den in der SMS beschriebenen Schritten, um deine Prämie einzulösen',
};
